import type { AdvertisementResponse } from '@dobrozem/sdk';

/**
 * Get advertisement area with priority logic:
 * 1. systemData.area (if set by moderator and not null) - has priority
 * 2. land.registry.area (from Vkursi) - fallback
 * 
 * This helper works both before and after SDK regeneration.
 */
export function getAdvertisementArea(advertisement: AdvertisementResponse): number | null | undefined {
  const ad = advertisement as AdvertisementResponse & {
    systemData?: {
      area?: number | null;
    };
  };
  
  // Пріоритет: systemData.area (якщо є число) > land.registry.area
  // Якщо systemData.area === null або undefined, використовуємо land.registry.area
  if (ad.systemData?.area !== null && ad.systemData?.area !== undefined) {
    return ad.systemData.area;
  }
  
  return advertisement.land.registry.area;
}
